import DateRange from 'carbon-react/esm/components/date-range';
import { DateRangeProps } from '../types/types';
import { useEffect, useMemo, useState, useRef } from 'react';
import {
  validateDateRange,
  adaptDateRangeEvent,
  extractDatesFromEvent,
  createFormattedDateValues,
  RawDateRangeChangeEvent,
} from '../utils/dateHelpers';
import Box from 'carbon-react/esm/components/box';
import Typography from 'carbon-react/esm/components/typography';

const DateRangeComponent = ({ value, onChange, onValidationChange }: DateRangeProps) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [_isInvalid, setIsInvalid] = useState(false);
  const [dateDebutError, setDateDebutError] = useState('');
  const [dateFinError, setDateFinError] = useState('');

  const startValue = value[0];
  const endValue = value[1];
  const startDate = useMemo(() => (startValue ? new Date(startValue) : null), [startValue]);
  const endDate = useMemo(() => (endValue ? new Date(endValue) : null), [endValue]);

  const { isRangeInvalid } = validateDateRange(startDate, endDate);
  const formattedValues = createFormattedDateValues(value[0], value[1]);

  useEffect(() => {
    if (onValidationChange) {
      const { isValid } = validateDateRange(startDate, endDate);
      onValidationChange(Boolean(isValid));
    }
  }, [isRangeInvalid, onValidationChange, startDate, endDate]);

  const handleChange = (event: RawDateRangeChangeEvent) => {
    const adaptedEvent = adaptDateRangeEvent(event);
    const { startDate: newStartDate, endDate: newEndDate } = extractDatesFromEvent(adaptedEvent);

    const validation = validateDateRange(newStartDate, newEndDate);
    setIsInvalid(validation.isRangeInvalid);
    setDateDebutError(validation.dateDebutError);
    setDateFinError(validation.dateFinError);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      if (validation.isValid) {
        onChange(adaptedEvent);
      }
    }, 500);
  };

  const dateProps = {
    value: formattedValues,
    onChange: handleChange,
    name: 'date-range',
    labelFrom: 'Dépôt du',
    labelTo: 'au',
    dateFormat: 'DD/MM/YYYY',
    startError: dateDebutError,
    endError: dateFinError,
  };

  return (
    <Box>
      <Box display="flex" mb={1}>
        <Box width="55%">
          <Typography variant="b" display="inline">
            Dépôt du
          </Typography>
        </Box>
        <Box width="45%">
          <Typography variant="b" display="inline">
            au
          </Typography>
        </Box>
      </Box>
      <DateRange {...dateProps} />
    </Box>
  );
};

export default DateRangeComponent;
